import { ShopOutlined } from '@ant-design/icons';

const menuAdminDispatchReviewer = [
  {
    key: 'daotian',
    name: '门店管家',
    menus: [
      {
        key: 'daotian_repair_order_dispatch',
        icon: ShopOutlined,
        name: '派单管理',
        subMenu: [
          {
            name: '业务统计',
            path: '/daotian/repair-order/statistics',
          },
          {
            name: '订单分配',
            path: '/daotian/repair-order/assign',
          }, {
            name: '订单管理',
            path: '/daotian/repair-order/manage',
          },
        ],
      },
      {
        key: 'daotian_repair_order_app',
        icon: ShopOutlined,
        name: '订单小程序',
        subMenu: [
          {
            name: '派单门店',
            path: '/daotian/repair-order/activation',
          }, {
            name: '用户列表',
            path: '/daotian/repair-order/weapp-users',
          },
        ],
      },
    ],
  },
];

export default menuAdminDispatchReviewer;
